const replacer = (_: any, p1: any, p2: any, p3: any, p4: any) => {
  return `(${p1})${p2 ? ' ' + p2 : ''} ${p3}-${p4}`
}

const formatPhone = (number: string) => {
  return number.replace(/(\d{2})(9?)(\d{4})(\d{4})/, replacer)
}

export { formatPhone }
